const { VUE_APP_XDB: XDB } = process.env;
import { hundun_route_type } from '@/common/enum';
import { ruan_route, hundun_route, limit_route } from '@/router/index';
export interface menu {
  name: string;
  path?: string;
  type?: string;
  children?: any[];
}
//软装菜单
export const ruan_menu: Array<menu> = [
  {
    name: '合同',
    path: `${XDB}/ruan/contract/list/index`,
    type: 'pie-chart'
  },
  {
    name: '用户',
    path: `${XDB}/ruan/apply/list/index`,
    type: 'desktop'
  },
  {
    name: '订单',
    path: `${XDB}/ruan/order/list/index`,
    type: 'inbox'
  }
];
export const ruan_sub_menu: Array<menu> = [
  {
    name: '页面',
    type: 'mail',
    children: ruan_route
  }
];
export const hundun_menu: Array<menu> = [
  {
    name: '学员管理',
    path: '/hundun/user-list'
  }
];
export const hundun_sub_menu: Array<menu> = [
  {
    name: '学员工作列表',
    children: hundun_route.filter((item: any) => item.meta.number === 2)
  },
  {
    name: '创商院',
    children: hundun_route.filter((item: any) => item.meta.number === 6)
  },
  {
    name: '企业管理',
    children: hundun_route.filter((item: any) => item.meta.number === hundun_route_type.company)
  },
  {
    name: '企业工作列表',
    children: hundun_route.filter((item: any) => item.meta.number === hundun_route_type.company_work)
  },
  {
    name: '数据中心',
    children: hundun_route.filter((item: any) => item.meta.number === 5)
  },
  {
    name: '设置',
    children: hundun_route.filter((item: any) => item.meta.number === 3)
  }
];
export const limit_menu: Array<menu> = [
  // {
  //   name: '权限管理',
  //   path: '/limit/index',
  // }
];
export const limit_sub_menu: Array<menu> = [
  {
    name: '权限管理',
    children: limit_route.filter((item: any) => item.meta.number === 2)
  }
];
